import { createContext } from "react";

const MoshiContext = createContext({ moshi_id: 5 });

export default MoshiContext